<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<footer class="footer">
	<div class="footer-content">
		<div class="footer-links">
			<a
				[routerLink]="'/' + paths.PRIVACY_STATEMENT"
				class="footer-link"
			>
				Privacy Statement
			</a>
			<a
				[routerLink]="'/' + paths.TERMS_OF_USE"
				class="footer-link"
			>
				Terms of Use
			</a>
		</div>
	</div>
</footer>
